import { render, staticRenderFns } from "./details.modal.vue?vue&type=template&id=b83e9f48&scoped=true"
import script from "./details.modal.vue?vue&type=script&lang=js"
export * from "./details.modal.vue?vue&type=script&lang=js"
import style0 from "./details.modal.vue?vue&type=style&index=0&id=b83e9f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83e9f48",
  null
  
)

export default component.exports